// node_modules
import { FC, useRef, ChangeEvent, MouseEvent } from "react"
// Enums
import { ToastTypeEnum } from "Enums";
// Helpers
import { ToastHelperSingleton } from "Helpers";

// Styles
import styles from "styles/buttons.module.scss";

type TFileInputButtonProps = {
    onFileSelected?: (file: File) => void
}

export const FileInputButton: FC<TFileInputButtonProps> = ({ onFileSelected }: TFileInputButtonProps) => {
    const fileInput = useRef<HTMLInputElement>(null);

    const handleFileInput = (event: ChangeEvent<HTMLInputElement>) => {
        if(!event.target.files || event.target.files.length === 0) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "Please select one image file to upload.");
            return;
        }

        const file = event.target.files[0];
        if (file.size > 2048000) {
            ToastHelperSingleton.showToast(ToastTypeEnum.Error, "The maximum file size for image is 2MB, please upload a smallar image.");
            return;
        }

        if(onFileSelected) {
            onFileSelected(file);
        }
    }

    const onButtonClick = (_event: MouseEvent<HTMLButtonElement>) => {
        if(fileInput.current) {
            fileInput.current.value = "";
            fileInput.current.click();
        } 
    } 

    return (
        <div>
            <input style={{display: "none"}} ref={fileInput} type="file" onChange={handleFileInput} />
            <button className={styles.whiteButton} onClick={onButtonClick}>Choose file</button>
        </div>
    );
}